const COMPONENT_XML_TEMPLATE: string = `<component>

	<previews>
		<preview width="320" height="240" style_bg_color="0xeee"/>
	</previews>

	<api>
		<!-- Add your API here here. For example 
		<prop name="prop1" type="int" default="0" help="What is this property?"/>
		-->
	</api>

	<styles>
		<style name="style_base" bg_color="0x6688ee"/>
	</styles>
	
	<view extends="lv_obj">
		<!-- Add widgets/components here -->
		<style name="style_base" />
	</view>

</component>
`;

export default COMPONENT_XML_TEMPLATE;
